import {
  withTranslation,
} from 'react-i18next';

import RegattaGroupsSectionView from './RegattaGroupsSectionView';

const TranslatedComponent = withTranslation()(RegattaGroupsSectionView);

const Component = TranslatedComponent;

export default Component;
